<form *ngIf="offer$ | async as OfferDetails; else loading" [formGroup]="formGroup" novalidate>
    <div appearance="outlined">
        <div fxLayout="column">
            <!-- <div fxLayout="row wrap" fxLayoutAlign="space-between">
                <div class="d-flex">
                    <h2>{{formGroup.controls.Detail.controls.Name.value == '' ? "Promo" :
                        formGroup.controls.Detail.controls.Name.value}}
                    </h2>
                    <button *ngIf="offerId !=='0' && canEdit() == true"
                        (click)="deleteRecord(OfferDetails?.Detail?.OfferVariantName)" class="version" mat-button>
                        {{formGroup.controls.Detail.controls.OfferVariantName.value}} <fa-icon
                            *ngIf=" OfferDetails?.Detail?.OfferVariantName !== 'Base'" style="color: mediumblue;"
                            [icon]="['fas', 'trash']"></fa-icon> </button>
                    <button (click)="navigateChildOffers()" mat-button type="button" color="accent"
                        *ngIf="offerId !=='0' && versionsCount > 1" class="view-all">View All Variants ({{ versionsCount
                        }})</button>
                </div>


                <div fxFlex="50" class="d-flex flex-end header-card-actions">
                    <mat-card-actions fxLayout="row" [fxLayoutAlign]="offerId != '0'?'space-between':'end'"
                        [ngClass]="{'flex-row-reverse': canEdit() == false}">
                        <div class="btn-width">
                            <button class="btn-right" mat-stroked-button type="button" (click)="cancel()">
                                <span *ngIf="!canEdit()">Close</span>
                                <span *ngIf="canEdit()">Cancel</span>
                            </button>
                            <button *ngIf="canEdit()" mat-raised-button type="button" (click)="save()"
                                [disabled]="formGroup.invalid" color="accent">
                                Save
                            </button>
                        </div>
                    </mat-card-actions>
                </div>
            </div> -->
            <div formGroupName="Detail" class="offer-details-form">
                <mat-accordion class="OfferDetails" multi>
                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Promo Details</mat-panel-title>
                            <mat-panel-description>Copy, Dates and Tags</mat-panel-description>
                        </mat-expansion-panel-header>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column">
                            <div fxLayout="column" fxFlex="auto" class="marginTop">
                                <div class="field-with-previous-step-hint" fxFlex fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                    [class.field--modified]="isPropertyModified('Name')">
                                    <mat-label>Promo Name</mat-label>
                                    <input [readonly]="!canEdit()" matInput type="text" formControlName="Name" />
                                    <mat-error *ngIf="formGroup.controls.Detail.controls.Name.hasError('required')">
                                        Promo Name is required
                                    </mat-error>
                                    <mat-error *ngIf="formGroup.controls.Detail.controls.Name.status=='INVALID'">
                                        {{formGroup.controls.Detail.controls.Name.errors!['maxlength'] && 'Maximum
                                        length can be
                                        '+formGroup.controls.Detail.controls.Name.errors!['maxlength']['requiredLength']+'.
                                        '}}
                                        {{formGroup.controls.Detail.controls.Name.errors!['pattern'] && 'Offer Name
                                        may only contain alphanumeric and .,;-#&*\'/ characters. '}}
                                    </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('Name') as text">{{ text }}</div>
                                </div>


                                <div fxLayout="row" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column">
                                    <div class="field-with-previous-step-hint" fxFlex fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                        [class.field--modified]="isPropertyModified('StartDate')">
                                        <mat-label>Promo Start Date</mat-label>
                                        <input [disabled]="canEdit() == false" matInput
                                            [matDatepicker]="startDatePicker" formControlName="StartDate"
                                            (dateChange)="onDateCommitted()">
                                        <mat-error
                                            *ngIf="formGroup.controls.Detail.controls.StartDate.hasError('required')">
                                            Start date is required.
                                        </mat-error>
                                        <mat-error
                                            *ngIf="formGroup.controls.Detail.controls.StartDate.status=='INVALID'">
                                            {{formGroup.controls.Detail.controls.StartDate.errors!['matDatepickerMax']
                                            && 'Start Date exceeded maximum year.'}}
                                        </mat-error>
                                        <mat-datepicker-toggle [disabled]="!canEdit()" matSuffix
                                            [for]="startDatePicker">
                                        </mat-datepicker-toggle>
                                        <mat-datepicker [disabled]="!canEdit()" #startDatePicker></mat-datepicker>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('StartDate') as text">{{ text }}</div>
                                </div>

                                    <div class="field-with-previous-step-hint" fxFlex fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                        [class.field--modified]="isPropertyModified('EndDate')">
                                        <mat-label>Promo End Date</mat-label>
                                        <input [disabled]="!canEdit()" matInput [matDatepicker]="endDatePicker"
                                            formControlName="EndDate" (dateChange)="onDateCommitted()">
                                        <mat-error
                                            *ngIf="formGroup.controls.Detail.controls.EndDate.hasError('required')">
                                            End date is required.
                                        </mat-error>
                                        <mat-error *ngIf="formGroup.controls.Detail.controls.EndDate.status=='INVALID'">
                                            {{formGroup.controls.Detail.controls.EndDate.errors!['matDatepickerMax'] &&
                                            'End Date exceeded maximum year.'}}
                                        </mat-error>
                                        <mat-datepicker-toggle [disabled]="!canEdit()" matSuffix
                                            [for]="endDatePicker"></mat-datepicker-toggle>
                                        <mat-datepicker [disabled]="!canEdit()" #endDatePicker></mat-datepicker>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('EndDate') as text">{{ text }}</div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column">
                            <div class="field-with-previous-step-hint" fxFlex="33" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('Headline')">
                                <mat-label>Headline</mat-label>
                                <textarea [readonly]="!canEdit()" matInput type="text"
                                    formControlName="Headline"></textarea>
                                <!-- <mat-error *ngIf="formGroup.controls.Detail.controls.Headline.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.Headline.errors!['pattern'] && 'Headline may
                                    only
                                    contain alphanumeric and .,;-#&*\'/ characters. '}}
                                </mat-error> -->
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('Headline') as text">{{ text }}</div>
                                </div>

                            <div class="field-with-previous-step-hint" fxFlex fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('BodyCopy')">
                                <mat-label>Body Copy</mat-label>
                                <textarea [readonly]="!canEdit()" matInput type="text"
                                    formControlName="BodyCopy"></textarea>
                                <mat-error *ngIf="formGroup.controls.Detail.controls.BodyCopy.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.BodyCopy.errors!['maxlength'] && 'Maximum
                                    length
                                    can be
                                    '+formGroup.controls.Detail.controls.BodyCopy.errors!['maxlength']['requiredLength']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.BodyCopy.errors!['pattern'] && 'Body Copy may
                                    only contain alphanumeric and .,;-#&*\'/ characters. '}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('BodyCopy') as text">{{ text }}</div>
                                </div>

                            <div class="field-with-previous-step-hint" fxFlex="50" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('Disclaimer')">
                                <mat-label>Disclaimer</mat-label>
                                <textarea [readonly]="!canEdit()" matInput type="text"
                                    formControlName="Disclaimer"></textarea>
                                <mat-error *ngIf="formGroup.controls.Detail.controls.Disclaimer.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.Disclaimer.errors!['maxlength'] && 'Maximum
                                    length can be
                                    '+formGroup.controls.Detail.controls.Disclaimer.errors!['maxlength']['requiredLength']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.Disclaimer.errors!['pattern'] && 'Disclaimer
                                    may
                                    only contain alphanumeric and .,;-#&*\'/ characters. '}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('Disclaimer') as text">{{ text }}</div>
                                </div>

                            <div class="field-with-previous-step-hint" fxFlex fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('ClientComment')">
                                <mat-label>Comments</mat-label>
                                <textarea [readonly]="!canEdit()" matInput type="text"
                                    formControlName="ClientComment"></textarea>
                                <mat-error *ngIf="formGroup.controls.Detail.controls.ClientComment.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.ClientComment.errors!['maxlength'] && 'Maximum
                                    length can be
                                    '+formGroup.controls.Detail.controls.ClientComment.errors!['maxlength']['requiredLength']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.ClientComment.errors!['pattern'] && 'Comment
                                    may
                                    only contain alphanumeric and .,;-#&*\'/ characters. '}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('ClientComment') as text">{{ text }}</div>
                                </div>

                            <div fxFlex>
                                <div fxFlex="50">
                                    <div style="max-height: 275px; overflow: auto;"
                                        *ngIf="additionalTexts && additionalTexts.controls && additionalTexts.controls.length > 0"
                                        formArrayName="AdditionalText"
                                        [class.field--modified]="isPropertyModified('AdditionalText')">
                                        <label>Custom Text</label>
                                        <ng-container
                                            *ngFor="let additionalText of additionalTexts.controls; let i = index">
                                            <div [formGroupName]="i" fxLayout="row" fxLayoutAlign="start center">
                                                <mat-form-field appearance="outline" fxFlex="100">
                                                    <textarea [readonly]="!canEdit()" matInput placeholder="Enter Text"
                                                        formControlName="addtionalTextDetail"
                                                        (blur)="onAdditionalTextCommitted()"></textarea>
                                                    <mat-error *ngIf="additionalText.status=='INVALID'">
                                                        {{additionalTexts.controls[i].get('addtionalTextDetail')?.errors?.['maxlength']
                                                        && 'Maximum length can be '+
                                                        additionalTexts.controls[i].get('addtionalTextDetail')?.errors?.['maxlength']['requiredLength']+'.'}}
                                                        {{additionalTexts.controls[i].get('addtionalTextDetail')?.errors?.['pattern']
                                                        && 'Comment may only contain alphanumeric and .,;-#&*\'/
                                                        characters. '}}
                                                    </mat-error>
                                                </mat-form-field>
                                                <mat-icon *ngIf="canEdit()" style="margin: 15px;" class="delete-btn"
                                                    (click)="deleteAddtionalText(i)">delete_forever</mat-icon>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('AdditionalText') as text">{{ text }}</div>
                                    <button *ngIf="canEdit()" type="button" style="margin: 10px;" mat-button
                                        (click)="addAdditionalText('')">
                                        <mat-icon class="add-course-btn">add</mat-icon>
                                        Add Custom Text
                                    </button>
                                </div>
                                <div fxFlex="50" style="margin-left: 3.5rem;">
                                    <div style="max-height: 275px; overflow: auto;">
                                        <label>Target Url</label>
                                        <div class="field-with-previous-step-hint" fxLayout="column">
                                            <mat-form-field appearance="outline" fxFlex="100"
                                                [class.field--modified]="isPropertyModified('TargetURL')">
                                                <input [readonly]="!canEdit()" matInput type="text"
                                                    formControlName="TargetURL" />
                                                <mat-error
                                                    *ngIf="formGroup.controls.Detail.controls.TargetURL.status=='INVALID'">
                                                    {{formGroup.controls.Detail.controls.TargetURL.errors!['maxlength']
                                                    && 'Maximum
                                                    length
                                                    can be
                                                    '+formGroup.controls.Detail.controls.TargetURL.errors!['maxlength']['requiredLength']+'.
                                                    '}}
                                                    {{formGroup.controls.Detail.controls.TargetURL.errors!['pattern'] &&
                                                    'TargetURL
                                                    may
                                                    only
                                                    contain alphanumeric characters. '}}
                                                </mat-error>
                                            </mat-form-field>
                                            <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('TargetURL') as text">{{ text }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="field-with-previous-step-hint" fxFlex="100" fxLayout="column">
                                <mat-form-field appearance="outline"
                                    [class.field--modified]="isPropertyModified('AlternateText')">
                                    <mat-label>Alternate Text</mat-label>
                                    <input [readonly]="!canEdit()" matInput type="text" formControlName="AlternateText" />
                                </mat-form-field>
                                <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('AlternateText') as text">{{ text }}</div>
                            </div>

                            <div fxFlex="100" [class.field--modified]="isPropertyModified('OfferTagIds', 'Tags')">
                                <app-pr1-offer-tags [placeholder]="'Associate Tag...'" [label]="'Offer Tags'"
                                    [selectedTagIds]="offerTagIds" (tagRemoved)="removeTag($event)"
                                    (tagAdded)="addTag($event)" [offerTagsFormControl]="tagCtrl"
                                    (tagSelectedEmitter)="tagSelected($event)"> </app-pr1-offer-tags>
                                <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('OfferTagIds', 'Tags') as text">{{ text }}</div>
                            </div>

                            <div class="field-with-previous-step-hint" fxFlex fxLayout="column">
                                <mat-form-field appearance="outline"
                                    [class.field--modified]="isPropertyModified('BadgeAssetId', 'Badge')">
                                    <mat-label>Badge</mat-label>
                                    <mat-select [disabled]="canEdit() == false" formControlName="BadgeAssetId">
                                        <mat-option *ngFor="let item of assetsforBadge" [value]="item?.Id"
                                            class="badge-dropdown">
                                            <img *ngIf="item?.WebUrl" class="badge-option-image" [src]="item?.WebUrl"
                                                alt="Offer image">
                                            <img mat-card-md-image *ngIf="!item?.WebUrl"
                                                src="./assets/images/default-image.png" alt="Offer image">
                                            <span>{{item?.AssetName}}</span>
                                        </mat-option>
                                        <mat-option [value]="noneValue">None</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('BadgeAssetId', 'Badge') as text">{{ text }}</div>
                            </div>

                            <mat-form-field appearance="outline" fxFlex="33" *ngIf="offerId != '0'">
                                <mat-label>Id</mat-label>
                                <input [readonly]="!canEdit()" matInput formControlName="Id" readonly>
                            </mat-form-field>

                            <div class="field-with-previous-step-hint" fxFlex fxLayout="column">
                                <mat-form-field appearance="outline"
                                    [class.field--modified]="isPropertyModified('ClientKey')">
                                    <mat-label>Client key</mat-label>
                                    <input [readonly]="!canEdit()" matInput type="text" formControlName="ClientKey" />
                                    <mat-error *ngIf="formGroup.controls.Detail.controls.ClientKey.hasError('required')">
                                        Client key is required
                                    </mat-error>
                                    <mat-error *ngIf="formGroup.controls.Detail.controls.ClientKey.status=='INVALID'">
                                        {{formGroup.controls.Detail.controls.ClientKey.errors!['maxlength'] && 'Maximum
                                        length
                                        can be
                                        '+formGroup.controls.Detail.controls.ClientKey.errors!['maxlength']['requiredLength']+'.
                                        '}}
                                        {{formGroup.controls.Detail.controls.ClientKey.errors!['pattern'] && 'Client Key may
                                        only contain alphanumeric and _-#&*\'/ characters. '}}
                                    </mat-error>
                                </mat-form-field>
                                <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('ClientKey') as text">{{ text }}</div>
                            </div>

                            <div class="field-with-previous-step-hint" fxFlex fxLayout="column">
                                <mat-form-field appearance="outline"
                                    [class.field--modified]="isPropertyModified('Rank')">
                                    <mat-label>Rank</mat-label>
                                    <input [readonly]="!canEdit()" matInput type="number" formControlName="Rank" (input)="onRankInput($event)" (blur)="onRankCommitted()" />
                                    <mat-error *ngIf="formGroup.controls.Detail.controls.Rank.status=='INVALID'">
                                        {{formGroup.controls.Detail.controls.Rank.errors!['max'] && 'Maximum number can be '
                                        + formGroup.controls.Detail.controls.Rank.errors!['max']['max'] + '. '}}
                                        {{formGroup.controls.Detail.controls.Rank.errors!['min'] && 'Minimum required number
                                        can be' + formGroup.controls.Detail.controls.Rank.errors!['min']['min'] + '. '}}
                                    </mat-error>
                                </mat-form-field>
                                <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('Rank') as text">{{ text }}</div>
                            </div>
                        </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Print-Related Details</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" class="paddingTop">
                            <div class="field-with-previous-step-hint" fxFlex="33" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('PrintPageId', 'PageNumber')">
                                <mat-label>Page Number</mat-label>
                                <mat-select [disabled]="!canEdit()" formControlName="PrintPageId">
                                    <mat-option *ngFor="let item of printPagesList" [value]="item?.Id"
                                        class="badge-dropdown">
                                        <span>{{item?.PageFrom}}</span>
                                    </mat-option>
                                </mat-select>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('PrintPageId', 'PageNumber') as text">{{ text }}</div>
                                </div>

                            <div class="field-with-previous-step-hint" fxFlex="33" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('Position')">
                                <mat-label>Position</mat-label>
                                <input [readonly]="!canEdit() || !formGroup['controls'].Detail['controls'].PrintPageId.value" matInput type="number" formControlName="Position" />
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('Position') as text">{{ text }}</div>
                                </div>
                        </div>
                    </mat-expansion-panel>

                    <app-dynamic-fields-section
                        *ngIf="(customFields$ | async)?.length"
                        [formGroup]="getCustomFieldsGroup()"
                        [customFields$]="customFields$"
                        [modifiedPropertyNames]="modifiedPropertyNames"
                        [modifiedPropertyOldValues]="modifiedPropertyOldValues"
                        [showChangesHighlight]="showChangesFromPreviousStep">
                    </app-dynamic-fields-section>

                </mat-accordion>
            </div>
        </div>
        <mat-card-actions class="card-footer-actions" fxLayout="row"
            [fxLayoutAlign]="offerId != '0' && OfferDetails?.Detail?.OfferVariantName == 'Base' ?'space-between':'end'"
            [ngClass]="{'flex-row-reverse': canEdit() == false}">
            <button mat-raised-button type="button" color="warn"
                *ngIf="(offerId != '0' && OfferDetails?.Detail?.OfferVariantName == 'Base') && canEdit()"
                (click)="deleteBaseRecord()">
                Delete
            </button>
            <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" fxLayoutAlign="end">
                <button class="btn-right" mat-stroked-button type="button" (click)="cancel()">
                    <span *ngIf="canEdit()">Cancel</span>
                    <span *ngIf="!canEdit()">Close</span>
                </button>
                <button *ngIf="canEdit()" mat-raised-button type="button" (click)="save()"
                    [disabled]="formGroup.invalid" color="accent">
                    Save
                </button>
            </div>
        </mat-card-actions>
    </div>
</form>

<ng-template #loading>
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>
